import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { SmartLink } from '../../SmartLink';
import { getImageCreditPrefix } from '../../../domain/utils/imageEntityUtils';
import { theme } from '../../../domain/theme';

const getStyles = (color, type) =>
  type === 'legacy'
    ? {
        wrapper: css`
          display: block;
          ${theme.font.family('regularWeb')};
          font-weight: 400;
          font-size: 0.75rem;
          letter-spacing: 3px;
          line-height: 1.5;
          text-transform: uppercase;
          color: ${color.text};
        `,
        title: css`
          color: ${color.link};
          font-weight: 700;
        `,
        link: css`
          border-bottom: 2px solid #fc0;
        `
      }
    : {
        wrapper: css`
          ${theme.font.family('medium')};
          font-size: 12px;
          line-height: 1.42;
          color: ${color.text};
          ${theme.mq.tablet} {
            ${theme.font.family('regularWeb')};
            text-transform: uppercase;
            letter-spacing: 3px;
          }
        `,
        title: css`
          color: ${color.link};
        `,
        link: css`
          position: relative;
          span {
            position: relative;
            z-index: 1;
          }
          &:before {
            background-color: #fc0;
            bottom: 0;
            content: '';
            height: 1px;
            left: 0;
            position: absolute;
            transition: height 0.3s;
            width: 100%;
            z-index: 0;
          }
          &:hover {
            &:before {
              height: 100%;
            }
          }
        `
      };

export const PhotographersLink = ({
  photographers,
  color = { text: '#333', link: '#333' },
  type = 'legacy'
}) => {
  const styles = getStyles(color, type);

  return photographers?.[0] ? (
    <span css={styles.wrapper}>
      {!photographers[0]?.entity?.prefix &&
        `${getImageCreditPrefix(photographers[0]?.entity?.creditPrefix)} `}
      {photographers.map((photographer, index) => {
        if (
          photographer?.entity?.photographer?.entity &&
          photographer.entity.photographer.entity.name !== 'NONE'
        ) {
          const mustDisplayLink =
            photographer.entity.photographer.entity.isPublished;

          return (
            <React.Fragment
              key={`${photographer.entity.photographer.entity.name}_${photographer.entity.suffix}_${index}`}
            >
              {index !== 0 && ', '}
              {photographer.entity.prefix !== null &&
                `${photographer.entity.prefix} `}

              {mustDisplayLink ? (
                <SmartLink
                  css={[styles.link, styles.title]}
                  to={photographer.entity.photographer.entity.path.alias}
                >
                  <span>{photographer.entity.photographer.entity.name}</span>
                </SmartLink>
              ) : (
                <span css={styles.title}>
                  {photographer.entity.photographer.entity.name}
                </span>
              )}
              {photographer.entity.suffix && ` ${photographer.entity.suffix}`}
            </React.Fragment>
          );
        }
        if (photographer?.entity?.photographer?.entity?.name === 'NONE') {
          return (
            <React.Fragment
              key={`${photographer.entity.photographer.entity.name}_${photographer.entity.suffix}_${index}`}
            >
              {index !== 0 && ', '}
              {photographer.entity.prefix !== null &&
                `${photographer.entity.prefix} `}
              {photographer.entity.suffix && (
                <span css={styles.title}>{photographer.entity.suffix}</span>
              )}
            </React.Fragment>
          );
        }
        return null;
      })}
    </span>
  ) : null;
};

PhotographersLink.propTypes = {
  photographers: PropTypes.arrayOf(PropTypes.any).isRequired,
  color: PropTypes.shape({ text: PropTypes.string, link: PropTypes.string }),
  type: PropTypes.oneOf(['legacy', 'default'])
};
